/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import dayjs from 'dayjs';
import * as eqpMonitorApi from '../../lib/api/eqpMonitor';
import EqpMonitorBoard from '../../components/eqpmng/EqpMonitorBoard';
import EqpDetailModal from '../../components/eqpmng/EqpDetailModal';
import { initialTabKeyForRunState } from '../../components/eqpmng/eqpDetailTabs';
import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';

const REFRESH_MS = 10000; // 현장 모니터링 화면이라 10초마다 돈다

const EqpMonitorMngContainer = () => {
  const { enqueueSnackbar } = useSnackbar();

  const [list, setList]               = useState([]);
  const [loading, setLoading]         = useState(false);
  const [lastRefresh, setLastRefresh] = useState(null);
  const [stateFilter, setStateFilter] = useState(null); // null = 전체
  const [selectedRow, setSelectedRow] = useState(null); // 상세창(보기 전용)에 열려 있는 장비 행

  const fetchBoard = useCallback(async (showSpinner) => {
    if (showSpinner) setLoading(true);
    try {
      const res = await eqpMonitorApi.getMonitorBoard();
      setList(eqpMonitorApi.extractList(res));
      setLastRefresh(dayjs());
    } catch (e) {
      enqueueSnackbar('모니터링 보드 조회 실패', { variant: 'error' });
    } finally {
      if (showSpinner) setLoading(false);
    }
  }, [enqueueSnackbar]);

  useEffect(() => {
    fetchBoard(true);

    // 탭이 백그라운드로 가면 자동 갱신을 멈춘다. 돌아오면 바로 한 번 갱신하고 다시 돈다.
    let timer = null;
    const start = () => { if (!timer) timer = setInterval(() => fetchBoard(false), REFRESH_MS); };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    const onVisibility = () => {
      if (document.visibilityState === 'visible') { fetchBoard(false); start(); } else { stop(); }
    };

    start();
    document.addEventListener('visibilitychange', onVisibility);
    return () => { stop(); document.removeEventListener('visibilitychange', onVisibility); };
  }, [fetchBoard]);

  // 카드를 누르면 같은 장비 상세창을 보기 전용(view)으로 연다(2026-10-19 - 장비관리에서 열 때와
  // 같은 창. 전엔 /eqpmng/data 로 이동해 전혀 다른 화면이 열렸다). 가동 중이면 가공 진행 탭,
  // 아니면 수집 데이터 탭으로 바로 들어간다.
  const handleCardClick = (row) => {
    setSelectedRow(row);
  };

  return (
    <Box sx={{ p: 3 }}>
      <BreadcrumbsContainer title="생산/생산 현황" />
      <Typography variant="h5" fontWeight={700} mb={2}>장비 모니터링</Typography>

      <EqpMonitorBoard
        list={list}
        loading={loading}
        lastRefresh={lastRefresh}
        stateFilter={stateFilter}
        onStateFilterChange={setStateFilter}
        onCardClick={handleCardClick}
        onRefresh={() => fetchBoard(true)}
      />

      <EqpDetailModal
        open={Boolean(selectedRow)}
        eqpData={selectedRow}
        onClose={() => setSelectedRow(null)}
        mode="view"
        initialTab={selectedRow ? initialTabKeyForRunState(selectedRow.runSt) : undefined}
      />
    </Box>
  );
};

export default EqpMonitorMngContainer;
